var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * 将任意对象转换成String，如果包含Error，则将Error转换为err.toString()
 * @param val any
 */
export function any2Str(val) {
    if (val instanceof Error)
        return String(val);
    return typeof val === 'object'
        ? JSON.stringify(val, (k, v) => v instanceof Error ? String(v) : v)
        : String(val);
}
/**
 * 生成一个 uuid
 */
export function uuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0;
        var v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}
/**
 * 获取buffer中未播放的剩余时长, 单位s
 */
export function remainBufferLength(videoEl) {
    const buffered = videoEl.buffered;
    if (buffered == null || buffered.length === 0)
        return 0;
    return buffered.end(buffered.length - 1) - videoEl.currentTime;
}
/**
 * 获取指定 cookie 值，若不存在则返回空串
 * @param key key
 * @returns value
 */
export function getCookie(key) {
    var _a, _b;
    const { cookie } = document;
    if (cookie == null)
        return '';
    return (_b = (_a = cookie.split(';')
        .filter(str => str.trim().length > 0)
        .map(it => it.split('='))
        .map(([k, v]) => [k.trim(), v.trim()])
        .find(([k]) => k === key)) === null || _a === void 0 ? void 0 : _a[1]) !== null && _b !== void 0 ? _b : '';
}
/**
 * 在节点上覆盖一张图片
 * @param imgSrc 图片 src, 值为 null 表示需要删除 cover 节点
 * @param container
 * @returns 移除图片节点
 */
export function coverImg(imgSrc, container) {
    var _a;
    const wrapClsName = 'web-player-video-cover-img-wrap';
    const imgClsName = 'web-player-video-cover-img';
    // 表示需要移除节点
    if (imgSrc == null) {
        (_a = container.querySelector(`.${wrapClsName}`)) === null || _a === void 0 ? void 0 : _a.remove();
        return;
    }
    // 复用 img 标签
    const oldImgEl = container.querySelector(`.${imgClsName}`);
    if (oldImgEl != null) {
        ;
        oldImgEl.src = imgSrc;
        return;
    }
    // 没有对应节点，则需要创建
    const divEl = document.createElement('div');
    divEl.classList.add(wrapClsName);
    divEl.style.cssText = `
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  `;
    const imgEl = document.createElement('img');
    imgEl.classList.add(imgClsName);
    imgEl.style.cssText = `
    max-width: 100%;
    max-height: 100%;
  `;
    imgEl.src = imgSrc;
    divEl.appendChild(imgEl);
    container.appendChild(divEl);
}
/**
 * 仅在首次执行一次函数，根据 id 判断是否执行过
 * @param id 函数表示
 * @param fn 需执行的函数
 */
export function runOnlyOnce(id, fn) {
    const execed = new Set();
    return (...args) => {
        if (execed.has(id))
            return;
        execed.add(id);
        fn(...args);
    };
}
/**
 * 保留指定小数位，但不要末尾的0和小数点
 * @param num 数值
 * @param digits 精度
 */
export function roundNumber(num, digits) {
    if (typeof num !== 'number')
        return 0;
    return Math.round(num * Math.pow(10, digits)) / Math.pow(10, digits);
}
/**
 * 函数节流
 */
export function throttle(func, wait) {
    let lastTime;
    return function (...rest) {
        if (lastTime == null ||
            Date.now() - lastTime > wait) {
            lastTime = Date.now();
            return func.apply(this, rest);
        }
    };
}
/**
 * 防抖
 */
export function debounce(func, wait) {
    let timer;
    return function (...rest) {
        // leading
        if (timer !== undefined) {
            window.clearTimeout(timer);
        }
        timer = window.setTimeout(() => {
            func.apply(this, rest);
        }, wait);
    };
}
/**
 * 返回一个一定时间之后 resolve 的 Promise
 */
export function sleep(ms) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield new Promise((resolve) => {
            setTimeout(resolve, ms);
        });
    });
}
/*
* 判断sei uuid
*/
export function equalsUuid(lhs, rhs) {
    if (lhs.length !== 16 || rhs.length !== 16) {
        return false;
    }
    for (var i = 0; i < 16; ++i) {
        if (!(lhs[i] === rhs[i])) {
            return false;
        }
    }
    return true;
}
/**
 * SEI信息中的 key（用于不同业务信息分类） 是 Uint8Array 类型
 * 将可阅读的 key（字符串）转换为 Uint8Array 进行对比
 * @param key
 */
export function seiKeyComparator(key) {
    const exceptKeyArr = new Uint8Array(16);
    for (var i = 0; i < key.length; ++i) {
        exceptKeyArr[i] = key.charCodeAt(i);
    }
    return (seiKeyArr) => {
        if (exceptKeyArr.length !== 16 || seiKeyArr.length !== 16)
            return false;
        for (var i = 0; i < 16; ++i) {
            if (!(exceptKeyArr[i] === seiKeyArr[i]))
                return false;
        }
        return true;
    };
}
const decoder = 'TextDecoder' in window
    ? new TextDecoder()
    : null;
export function uint8ArrayToString(bytes) {
    if (decoder == null)
        return '';
    return decoder.decode(bytes);
}
/**
 * 随机延迟执行
 * @param time: number ms 范围:[0, time)
 */
export function disperseAction(time, act) {
    const timer = setTimeout(() => {
        act();
    }, Math.floor(Math.random() * time));
    return () => {
        clearTimeout(timer);
    };
}
// 判断是否支持webp格式
export const isWebPSupported = () => {
    let isSupported = false;
    try {
        const canvas = document.createElement('canvas');
        canvas.width = 1;
        canvas.height = 1;
        isSupported = canvas.toDataURL('image/webp').startsWith('data:image/webp');
    }
    catch (err) { }
    return isSupported;
};
export const isSupportDolby = () => {
    const v = document.createElement('video');
    return v.canPlayType('video/mp4;codecs="ec-3"') === 'probably' &&
        v.canPlayType('video/mp4;codecs="ac-3"') === 'probably';
};
export const formatTime = (seconds) => {
    const hour = Math.floor(seconds / 3600);
    const min = `0${Math.floor((seconds - hour * 3600) / 60)}`.slice(-2);
    const sec = `0${Math.floor(seconds % 60)}`.slice(-2);
    return `${hour !== 0 ? (hour.toFixed(0) + ':') : ''}${min}:${sec}`;
};
export function loadScript(src) {
    return __awaiter(this, void 0, void 0, function* () {
        const script = document.createElement('script');
        const head = document.getElementsByTagName('head')[0];
        const rs = new Promise((resolve, reject) => {
            script.onload = () => {
                resolve();
            };
            script.onerror = reject;
        });
        script.src = src;
        if (head != null)
            head.appendChild(script);
        return rs;
    });
}
//# sourceMappingURL=common-utils.js.map